import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonModel } from '@notino/react-styleguide';

import { skinAnalyserMessages } from '../messages';
import { StyledButton } from '../styled';

interface ActionButtonProps {
  onOpenSkinAnalyzer: () => void;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onOpenSkinAnalyzer,
}) => {
  const handleClick = (e: React.SyntheticEvent<HTMLElement, Event>) => {
    e.stopPropagation();
    onOpenSkinAnalyzer();
  };

  return (
    <StyledButton
      onClick={handleClick}
      buttonStyle={ButtonModel.Styles.secondary}
      type="button"
    >
      <FormattedMessage {...skinAnalyserMessages.skinAnalyserRunDiagnostic} />
    </StyledButton>
  );
};
